import React from 'react';
import PropTypes from 'prop-types';
import reqwest from 'reqwest';
import equal from 'deep-equal';

class Fetch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: false,
    };
  }
  componentWillMount() {
    if (this.props.loadOnMount) {
      reqwest({
        url: this.props.url,
        data: {
          ...this.props.data,
        },
        method: this.props.method,
        crossOrigin: true,
        success: data => {
          this.handleSuccess(data);
        },
      });
    }
  }
  componentWillUpdate(nextProps) {
    if (equal(nextProps.data, this.props.data)) {
      return;
    }
    reqwest({
      url: nextProps.url,
      data: {
        ...nextProps.data,
      },
      method: this.props.method,
      crossOrigin: true,
      success: data => {
        this.handleSuccess(data);
      },
    });
  }
  handleSuccess = data => {
    let parsedData = data;
    if (typeof parsedData !== 'object') {
      parsedData = JSON.parse(data);
    }
    this.setState({
      data: parsedData,
    });
  };
  render() {
    return this.props.children(this.state.data);
  }
}

Fetch.propTypes = {
  children: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  data: PropTypes.object,
  loadOnMount: PropTypes.bool,
  method: PropTypes.oneOf(['GET', 'POST']),
};

Fetch.defaultProps = {
  loadOnMount: true,
  data: {},
  method: 'POST',
};

export default Fetch;



// WEBPACK FOOTER //
// ./src/js/components/Fetch.js